<template>
  <div class="pageStyle">
    <!-- 内容输入区域 -->
    <div class="header">
      <div class="title">新增跟进记录</div>
      <div class="input">
        <div class="item">
          <!-- <span class="item-title">跟进内容</span> -->
          <div class="tag">
            <span
              @click="addTag(item)"
              v-for="(item, index) in tagList"
              :key="index"
              >{{ item }}</span
            >
          </div>
          <van-field
            v-model="form.content"
            rows="3"
            autosize
            type="textarea"
            placeholder="请填写跟进内容"
          />
        </div>
        <div class="item">
          <span class="item-title">跟进是否有效</span>
          <van-radio-group v-model="form.maintainResult" direction="horizontal">
            <van-radio name="true" shape="square" checked-color="#066EF7"
              >是</van-radio
            >
            <van-radio name="false" shape="square" checked-color="#066EF7"
              >否</van-radio
            >
          </van-radio-group>
        </div>
        <div class="btn">
          <span @click="toAdd">保存跟进记录</span>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="title">历史跟进记录</div>
      <div class="cardBox">
        <div class="item" v-for="(item, index) in dataList" :key="index">
          <div>{{ parseTime(item.createDateTime) }}</div>
          <div>
            {{ item.content }}
          </div>
          <div>{{ item.maintainResult ? "有效" : "无效" }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { parseTime } from "@/utils/index.js";
import Vue from "vue";
import {
  RadioGroup,
  Radio,
  Icon,
  Dialog,
  Form,
  Field,
  Empty,
  List,
  Notify,
  Toast,
} from "vant";
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Icon);
Vue.use(Form);
Vue.use(Field);
Vue.use(Empty);
Vue.use(Notify);
Vue.use(List);
import { xcMaintenance, addXcMaintenance } from "@/api/xcCustomer";
export default {
  name: "XcExhibitionSystemApplyRecord",

  created() {
    //读取params
    let query = this.$route.query;
    this.query.customerId = query.customerId;
    this.query.enterpriseId = query.id;
    this.form.enterpriseId = query.id;
    this.form.customerId = query.customerId;
    this.getXcMaintenanceData();
  },
  data() {
    return {
      params: {
        size: 10,
        page: 0,
        sort: "createDateTime,desc",
      },
      dataList: [],
      form: {
        enterpriseId: "",
        content: "",
        maintainResult: "",
      },
      query: {
        size: 999,
        page: 0,
        sort: "createDateTime,desc",
        createDateTime: [],
      },
      tagList: ["联系不上", "无效客户", "不需要业务"],
    };
  },

  methods: {
    parseTime,
    // 获取订单数据
    getXcMaintenanceData() {
      Toast.loading({
        message: "加载中",
        forbidClick: true,
        loadingType: "spinner",
        duration: 0,
        overlay: true,
      });
      xcMaintenance(this.query)
        .then((res) => {
          this.dataList = res.content;
          Toast.clear();
        })
        .catch((err) => {
          console.log("err", err);
          Toast.clear();
        });
    },
    toAdd() {
      if (!this.form.content) {
        Toast.fail("请填写跟进内容");
        return false;
      }
      if (this.form.maintainResult === "") {
        Toast.fail("请选择跟进是否有效");
        return false;
      }
      Toast.loading({
        message: "加载中",
        forbidClick: true,
        loadingType: "spinner",
        duration: 0,
        overlay: true,
      });
      addXcMaintenance(this.form)
        .then((res) => {
          Toast.clear();
          Notify({ type: "success", message: "新增成功" });
          this.getXcMaintenanceData();
          this.toReset();
        })
        .catch((err) => {
          Toast.clear();
          console.log("err", err);
        });
    },
    toReset() {
      this.form.content = "";
      this.form.maintainResult = "";
    },
    addTag(val) {
      if (this.form.content) {
        this.form.content = this.form.content + "，" + val;
      } else {
        this.form.content = val;
      }
    },
  },
};
</script>
<style scoped src="./index.css"></style>



// WEBPACK FOOTER //
// src/view/myCustomer/module/maintainRecords/index.vue